import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';

const STORAGE_KEY = 'pos24_ticket_actions';

export default class TicketSettings extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            caption: '',
            commandName: '',
            commandValue: '',
            color: '#ffffff',
            foreground: '#000000',
            adminOnly: false,
            requiresTable: true,
            actions: this.loadActions(),
            message: ''
        };
    }

    loadActions = () => {
        try {
            const raw = localStorage[STORAGE_KEY];
            return raw ? JSON.parse(raw) : [];
        } catch (e) {
            return [];
        }
    }

    saveActions = (actions) => {
        localStorage[STORAGE_KEY] = JSON.stringify(actions || []);
    }

    addAction = () => {
        const caption = (this.state.caption || '').trim();
        const commandName = (this.state.commandName || '').trim();
        const commandValue = (this.state.commandValue || '').trim();

        if (!caption || !commandName) {
            this.setState({ message: 'Buton adı ve command adı zorunludur.' });
            return;
        }

        const action = {
            caption: caption,
            commandName: commandName,
            commandValue: commandValue,
            color: (this.state.color || '#ffffff').trim(),
            foreground: (this.state.foreground || '#000000').trim(),
            adminOnly: this.state.adminOnly === true,
            requiresTable: this.state.requiresTable === true
        };

        const actions = this.state.actions.concat([action]);

        this.saveActions(actions);

        this.setState({
            actions: actions,
            caption: '',
            commandName: '',
            commandValue: '',
            color: '#ffffff',
            foreground: '#000000',
            adminOnly: false,
            requiresTable: true,
            message: 'Action eklendi.'
        });
    }

    removeAction = (index) => {
        const actions = this.state.actions.filter((x, i) => i !== index);

        this.saveActions(actions);

        this.setState({
            actions: actions,
            message: 'Action kaldırıldı.'
        });
    }

    clearAll = () => {
        localStorage.removeItem(STORAGE_KEY);

        this.setState({
            actions: [],
            message: 'Tüm ticket action ayarları temizlendi.'
        });
    }

    goBack = () => {
        this.context.router.push('/login');
    }

    render() {
        return (
            <div style={{
                padding: '20px',
                height: '100vh',
                overflowY: 'auto',
                WebkitOverflowScrolling: 'touch',
                boxSizing: 'border-box'
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '15px'
                }}>

                    <h4 style={{
                        margin: 0,
                        fontWeight: '500'
                    }}>
                        Ticket / Sipariş Ayarları
                    </h4>

                    <RaisedButton
                        label="Geri"
                        onClick={this.goBack}
                    />

                </div>

                <TextField
                    floatingLabelText="Buton Adı"
                    hintText="Örn: Hesap Yaz"
                    value={this.state.caption}
                    onChange={(e) => this.setState({ caption: e.target.value })}
                    fullWidth={true}
                />

                <TextField
                    floatingLabelText="Automation Command"
                    hintText="Örn: Hesap Yaz"
                    value={this.state.commandName}
                    onChange={(e) => this.setState({ commandName: e.target.value })}
                    fullWidth={true}
                />

                <TextField
                    floatingLabelText="Command Value"
                    hintText="Örn: Müşteri / boş bırakılabilir"
                    value={this.state.commandValue}
                    onChange={(e) => this.setState({ commandValue: e.target.value })}
                    fullWidth={true}
                />

                <div style={{ marginTop: '15px' }}>
                    <label>Buton Rengi</label>
                    <br />
                    <input
                        type="color"
                        value={this.state.color}
                        onChange={(e) => this.setState({ color: e.target.value })}
                        style={{ width: '80px', height: '36px' }}
                    />
                    <span style={{ marginLeft: '10px' }}>{this.state.color}</span>
                </div>

                <div style={{ marginTop: '15px' }}>
                    <label>Yazı Rengi</label>
                    <br />
                    <input
                        type="color"
                        value={this.state.foreground}
                        onChange={(e) => this.setState({ foreground: e.target.value })}
                        style={{ width: '80px', height: '36px' }}
                    />
                    <span style={{ marginLeft: '10px' }}>{this.state.foreground}</span>
                </div>

                <Checkbox
                    label="Sadece Admin Kullanabilir"
                    checked={this.state.adminOnly}
                    onCheck={(e, checked) => this.setState({ adminOnly: checked })}
                />

                <Checkbox
                    label="Masa Seçili Olmalı"
                    checked={this.state.requiresTable}
                    onCheck={(e, checked) => this.setState({ requiresTable: checked })}
                />

                <br />

                <RaisedButton label="Listeye Ekle" primary={true} onClick={this.addAction} />
                {' '}
                <RaisedButton label="Tümünü Temizle" onClick={this.clearAll} />

                <br />
                <br />

                <div>{this.state.message}</div>

                <h4>Eklenen Ticket Actions</h4>

                {this.state.actions.length === 0 &&
                    <div>Henüz action eklenmedi.</div>
                }

                {this.state.actions.map((action, index) =>
                    <div
                        key={index}
                        style={{
                            padding: '10px',
                            marginBottom: '8px',
                            border: '1px solid #ddd',
                            borderRadius: '4px'
                        }}
                    >
                        <div><b>{action.caption}</b></div>
                        <div>Command: {action.commandName}</div>
                        <div>Value: {action.commandValue || '-'}</div>
                        <div>Admin: {action.adminOnly ? 'Evet' : 'Hayır'}</div>
                        <div>Masa Zorunlu: {action.requiresTable ? 'Evet' : 'Hayır'}</div>

                        <br />

                        <RaisedButton
                            label="Listeden Kaldır"
                            onClick={() => this.removeAction(index)}
                        />
                    </div>
                )}
            </div>
        );
    }
}

TicketSettings.contextTypes = {
    router: React.PropTypes.object
};


// WEBPACK FOOTER //
// ./app/components/TicketSettings.jsx